// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from "firebase/analytics"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2eFWhXA7WNaMjiiMPmHU4_5__QQNIudY",
  authDomain: "skyfam-news.firebaseapp.com",
  projectId: "skyfam-news",
  storageBucket: "skyfam-news.appspot.com",
  messagingSenderId: "482932656078",
  appId: "1:482932656078:web:9f4a6bf366d69c390e0d9f",
  measurementId: "G-3SY8XK7Y5X"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)

const db = getFirestore(app)
export { db }